import * as sagaEffects from 'redux-saga/effects';
import { getFirestore } from 'redux-firestore';
import { getFirebase } from 'react-redux-firebase';
import { getIntl } from '@ackee/jerome/antd';
import message from 'antd/lib/message';

import * as loglevel from 'config/loglevel';

import types from '../actionTypes';

const { takeEvery } = sagaEffects;

function* handler({ meta }) {
    const firestore = getFirestore(getFirebase());
    const intl = yield getIntl();
    try {
        yield firestore.setListener({
            collection: `imports/${meta.importId}/logs`,
            storeAs: 'logs',
            orderBy: ['timestamp', 'desc'],
        });
    } catch (e) {
        loglevel.error(e);
        message.error(intl.formatMessage({ id: 'errors.imports.listenLogs' }));
    }
}

export default function* () {
    yield takeEvery(types.LISTEN_LOGS, handler);
}
